export { _constructContentQuery as constructContentQuery };

const _constructContentQuery = (params) => {
  const queryString = [];

  params = params || {};

  queryString.push("pageSize=" + params.pageSize || 25);
  queryString.push("pageOffset=" + params.pageOffset || 0);
  if (params.sortField) {
    queryString.push("sortField=" + params.sortField);
  }
  if (params.sortDirection) {
    queryString.push("sortDirection=" + params.sortDirection);
  }
  if (params.sourceFilter) {
    queryString.push("sourceFilter=" + params.sourceFilter);
  }
  if (params.typeFilter) {
    queryString.push("typeFilter=" + params.typeFilter);
  }
  if (params.start) {
    queryString.push("start=" + params.start);
  }
  if (params.end) {
    queryString.push("end=" + params.end);
  }
  if (params.alertsIdFilter) {
    queryString.push("alertIdFilter=" + params.alertsIdFilter);
  }
  if (params.topicFilter) {
    queryString.push("topicFilter=" + params.topicFilter);
  }
  if (params.search) {
    queryString.push("search=" + params.search);
  }
  if (params.geoOnly) {
    queryString.push("geoOnly=" + params.geoOnly);
  }
  if (params.aoiId) {
    queryString.push("aoiId=" + params.aoiId);
  }
  if (params.bounds) {
    queryString.push("bounds=" + params.bounds);
  }
  if (params.veracityFilter) {
    queryString.push("veracityFilter=" + params.veracityFilter);
  }
  if (params.alertStats) {
    queryString.push("alertStats=" + params.alertStats);
  }

  return "?" + queryString.join("&");
};
